// 问卷调查
import { getTreatmentDayitemNext, dayitemStepsubmit, getTreatmentDayitem } from '@/api/dialogue'
import { Dialog } from 'vant';
import Router from '@/router'
import { readSurveyDraft, clearSurveyDraft } from '@/utils/surveyDraft';
export default {
  state: {
    header: '',
    stepId: '', // 主键id
    instanceId: '', // 
    surveyList: [], // 当前问卷list
    resumeIndex: 0,
    code: '',
    surveyDialogueList: [], // 结束时对话
    surveyEnd: false, // 问卷 是否 已结束
    codeName: 'PHQ-9健康问卷', //
    codeNameArr: {
      phq9_scale: 'PHQ-9健康问卷',
      gad7_scale: 'GAD-7自评量表',
      isi_scale: '失眠严重指数量表',
      mood_scale: '积极情绪和消极情绪量表',
    }
  },
  getters: {
  },
  mutations: {
    setSurveyResumeIndex(state, payload) {
      state.resumeIndex = payload;
    },
    // 设置主id
    setStepId(state, payload) {
      state.stepId = payload;
    },
    // 设置instanceId
    setInstanceId(state, payload) {
      state.instanceId = payload;
    },
    // 设置标题
    setCode(state, payload) {
      state.code = payload;
    },
    // 设置标题
    setHeader(state, payload) {
      state.header = payload;
    },
    // 设置问卷list
    setSurveyList(state, payload) {
      state.surveyList = payload;
    },
    // 设置list
    setSurveyDialogueList(state, payload) {
      state.surveyDialogueList = payload;
    },
    // 设置list
    setSurveyEnd(state, payload) {
      state.surveyEnd = payload;
    },
    setCodeName(state, payload) {
      state.codeName = payload;
    },
  },
  actions: {
    // 获取子任务历史
    async getSurveyList({ commit, dispatch }, payload) {
      try {
        const resData = await getTreatmentDayitem(payload);
        const useData = JSON.parse(resData[0].message);
        let questionsData = useData.step_data.questions;
        questionsData = questionsData.map(item => {
          return {
            title: item.qstContext.title,
            options: item.qstContext.options,
          }
        })
        commit('setStepId', useData.step_id);
        commit('setInstanceId', useData.step_data.instance_id);
        commit('setSurveyList', questionsData);
        if(useData.length === 0) {
          dispatch('getTreatmentDayitemNext', payload)
        }
        return useData;
      } catch (error) {
        console.log(error)
        return false;
      }
    },
    // 获取子任务下一项内容
    async getSurveyNext({ state, commit, rootState }, payload) {
      try {
        const resData = await getTreatmentDayitemNext(payload);
        const useData = resData;
        // 如果是答题类型
          if(useData.step_type === 'SYS_INFO') {
            Dialog({
              message: useData.step_data.content
            }).then(() => {
              Router.back()
            });
            return;
          }
        if(useData.step_type === 'survey_questions') {
          const draft = readSurveyDraft(payload.id, useData.step_id);
          let questionsData = useData.step_data.questions;
          questionsData = questionsData.map(item => {
            return {
              code: item.code,
              type: item.qstContext.type,
              hidden: item.qstContext.hidden,
              title: item.qstContext.title,
              options: item.qstContext.options,
              selectVal: item.qstContext.options.some(option => option.value === draft.answers?.[item.code])
                ? draft.answers[item.code] : ''
            }
          })
          
          commit('setCodeName', state.codeNameArr[useData.step_data.code]);
          commit('setHeader', useData.step_data.header);
          commit('setCode', useData.step_data.code);
          commit('setStepId', useData.step_id);
          commit('setInstanceId', useData.step_data.instance_id);
          commit('setSurveyList', questionsData);
          const unanswered = questionsData.findIndex(item => item.selectVal === '' || item.selectVal == null);
          const resumeIndex = Number.isInteger(draft.currentIndex) ? draft.currentIndex : Math.max(0, unanswered);
          commit('setSurveyResumeIndex', Math.min(questionsData.length - 1, Math.max(0, resumeIndex)));
        } else if(useData.step_type === 'survey_report') {
          commit('setSurveyEnd', true);
        } else {
          let useList = [];
          useList = [
            ...state.surveyDialogueList,
            {
              ...resData,
              id: payload.id,
              step_id: resData.step_id,
              instance_id: resData.step_data.instance_id,
              type: rootState.itemTypeList[resData.step_type],
              item_type: resData.step_type,
              text: resData.step_data.content || '',
              confirmTxt: resData.step_data.confirm || '',
              cancelTxt: resData.step_data.cancel || '',
              cardMode: 'dialogue',
              isShowTime: true
            }
          ];
          commit('setSurveyDialogueList', useList);
        }
        return resData
      } catch (error) {
        console.log(error)
        return false;
      }
    },
    // 子任务提交
    async surveyStepsubmit({ state }, payload) {
      try {
        const params = {
          id: payload.id,
          step_id: state.stepId,
          step_data: {
            survey: {
              id: state.instanceId,
              surveyType: 2,
              qstList: state.surveyList.map((item) => {
                return {
                  qstCode: item.code,
                  answer: { val: item.selectVal}
                }
              })
            },
          },
        };
        const resData = await dayitemStepsubmit(params);
        clearSurveyDraft(payload.id, state.stepId);
        console.log(resData);
        return resData;
      } catch (error) {
        console.log(error);
        return false;
      }
    },
  }
}
